import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatchValidator(matchControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;
    const matchControl = control.parent.get(matchControlName);
    if (!matchControl) return null;
    if (!control.value) return null; // Let 'required' handle empty
    return control.value === matchControl.value ? null : { passwordMismatch: true };
  };
}
